import React from 'react';
import { Helmet } from 'react-helmet';
import config from 'sharedConfig';

export default function BrandPageHeadTags(props) {
  const title = `${props.brandname} | Saucey: Alcohol Delivery`;
  const description = `Discover ${props.brandname} on Saucey. Order online & enjoy free 30-min local delivery or get items shipped directly to your door in 2 days.`;
  const url = config.site.url + '/brands/' + encodeURIComponent(props.slug);
  const json = JSON.stringify({
    '@context': 'http://schema.org',
    '@type': 'Brand',
    name: props.brandname
  });

  return (
    <Helmet>
      <title>{title}</title>
      <meta name="title" content={title} />
      <meta name="description" content={description} />
      <link rel="canonical" href={url} />
      <script type="application/ld+json">{json}</script>
    </Helmet>
  );
}
